import { isCashOnDeliveryPayment } from "../config/paymentMethods";

const normalizeText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "")
    .replace(/\s+/g, " ");

export const isOnlineCardPayment = (orderOrMethod) => {
  const method =
    typeof orderOrMethod === "string"
      ? orderOrMethod
      : orderOrMethod?.paymentMethod || orderOrMethod?.paymentType;
  const normalized = normalizeText(method);
  const compact = normalized.replace(/\s+/g, "");

  return normalized.includes("карт") && compact.includes("онлайн");
};

const getPaymentStatusValue = (order) =>
  order?.paymentStatus ||
  order?.onlinePaymentStatus ||
  order?.monoInvoiceStatus ||
  order?.transactionData?.lastProviderPayload?.status ||
  order?.transactionData?.rawProviderResponse?.status ||
  "";

export const isOnlinePaymentPaid = (order) => {
  const status = normalizeText(getPaymentStatusValue(order));
  return status === "paid" || status === "success";
};

export const getOnlinePaymentStatusLabel = (order) => {
  if (!isOnlineCardPayment(order)) return null;

  if (
    order?.additionalPaymentStatus === "pending" &&
    Number(order?.additionalPaymentAmount || 0) > 0
  ) {
    return `Очікує доплату: ${Number(order.additionalPaymentAmount).toFixed(2)} ₴`;
  }

  switch (normalizeText(getPaymentStatusValue(order))) {
    case "paid":
    case "success":
      return "Сплачено";
    case "pending":
    case "processing":
    case "created":
      return "Очікує оплати";
    case "failed":
    case "failure":
      return "Оплата не пройшла";
    case "expired":
      return "Термін оплати минув";
    case "canceled":
    case "cancelled":
      return "Оплату скасовано";
    case "reversed":
      return "Оплату повернено";
    case "partially_paid":
      return "Частково оплачено";
    case "partially_refunded":
      return "Оплата успішна";
    case "refunded":
      return "Оплату повернено";
    default:
      return "Статус оплати невідомий";
  }
};

export const getOnlinePaymentStatusTone = (order) => {
  if (!isOnlineCardPayment(order)) return null;

  if (order?.additionalPaymentStatus === "pending") {
    return "paymentPending";
  }

  switch (normalizeText(getPaymentStatusValue(order))) {
    case "paid":
    case "success":
      return "paid";
    case "pending":
    case "processing":
    case "created":
    case "partially_paid":
      return "paymentPending";
    case "failed":
    case "failure":
    case "expired":
    case "canceled":
    case "cancelled":
    case "reversed":
    case "refunded":
      return "unpaid";
    case "partially_refunded":
      return "paid";
    default:
      return "paymentUnknown";
  }
};

export const isOrderPaymentSettled = (order) => {
  if (isOnlineCardPayment(order)) return isOnlinePaymentPaid(order);

  if (order?.paymentMethod === "Оплата за реквізитами") {
    return !!order?.paymentControl;
  }

  if (
    isCashOnDeliveryPayment(order?.paymentMethod) &&
    order?.status === "Отримано"
  ) {
    return true;
  }

  return false;
};

export const getPaymentStatusLabel = (order) =>
  getOnlinePaymentStatusLabel(order) ||
  (isOrderPaymentSettled(order) ? "Сплачено" : "Не сплачено");

export const getPaymentStatusTone = (order) =>
  getOnlinePaymentStatusTone(order) ||
  (isOrderPaymentSettled(order) ? "paid" : "unpaid");
